import { RootState } from '../store'

export const carsSelector = (state: RootState) => {
  const { cars } = state

  return cars
}

export const commercialCarsSelector = (state: RootState) =>
  state.cars.cars.filter((car) => car.commercial)
